import { Component, OnInit } from '@angular/core';
import { TranslationService, I18nModule } from '@spartacus/core';
import { CustomProductsService } from '../custom-products/custom-products.service';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { CommonPageBreadcrumbsComponent } from '../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-custom-mycompany',
    templateUrl: './custom-mycompany.component.html',
    styleUrls: ['./custom-mycompany.component.scss'],
    imports: [CommonPageBreadcrumbsComponent, RouterLink, I18nModule]
})
export class CustomMycompanyComponent implements OnInit {
  protected userAccountFacade?: UserAccountFacade;
  title: any;
  navigationData: string;
  customerId: any;
  loggedinUser: any;
  constructor(private translation: TranslationService,
              private customProductsService: CustomProductsService) { }

  ngOnInit(): void {
    this.customProductsService.getHomeLinkActive(false);
    this.translation.translate('breadcrumb.myCompany.pageTitle').subscribe(res => {
      this.title = res;
    });
    this.translation.translate('breadcrumb.myCompany.breadcrumb').subscribe(res => {
      this.navigationData = res;
    });
  }

}
